import EntityCreateView from './EntityFormView';

export default EntityCreateView;
